export default class TipsType {
  constructor(code) {
    this.code = code;
  }

  getCode() {
    return this.code;
  }
}

TipsType.WARN = new TipsType('warn');
TipsType.INFO = new TipsType('info');
TipsType.SUCCESS = new TipsType('success');
TipsType.ERROR = new TipsType('error');

Object.freeze(TipsType);
